import api from '@/apis'
import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import type { QuizSubmitRequest, QuizSubmitResponse } from '@/types/quiz'

import { MOCK_QUIZ_SUBMIT_CORRECT, MOCK_QUIZ_SUBMIT_INCORRECT } from './mocks'

export const apiPostQuizSubmit = async (quizId: number, body: QuizSubmitRequest): Promise<QuizSubmitResponse> => {
  if (IS_MOCK) {
    await mockDelay(100)
    return Math.random() < 0.5 ? MOCK_QUIZ_SUBMIT_CORRECT : MOCK_QUIZ_SUBMIT_INCORRECT
  }
  return await api.post<QuizSubmitResponse>(`/quizzes/${quizId}/submit`, body)
}
